var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFeatherEyeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.328,
  height: 21.328,
  viewBox: "0 0 21.328 21.328"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-eye-off",
  "data-name": "Icon feather-eye-off",
  transform: "translate(-0.086 -0.086)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1394",
  "data-name": "Path 1394",
  d: "M15.745,17.722a8.468,8.468,0,0,1-5,1.732c-5.886,0-9.25-6.727-9.25-6.727a15.515,15.515,0,0,1,4.255-5M8.984,6.2A7.669,7.669,0,0,1,10.75,6C16.636,6,20,12.727,20,12.727a15.557,15.557,0,0,1-1.816,2.682m-5.651-.9a2.523,2.523,0,1,1-3.565-3.565",
  transform: "translate(0 -1.977)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1395",
  "data-name": "Path 1395",
  d: "M1.5,1.5,20,20",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}))));
export { SvgIconFeatherEyeOff as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon feather-eye-off.4ece591b724db5488e381eb562934d26.svg";